import Loading from "@components/common/Loading";
import Notification from "@components/common/Notification";
import SelectInput from "@components/form/SelectInput";
import { TextInputDefault } from "@components/form/TextInput";
import { API_URL } from "@redux/api";
import { setCredentials } from "@redux/slices/authSlice";
import { RootState } from "@redux/store";
import { AdminAccountInfo, validateAccountInfo } from "@redux/validations/accountSettings";
import { roleOptions } from "@static/data";
import axios from "axios";
import { useEffect, useState } from "react"
import { NotificationType } from "react-app-env";
import { useDispatch, useSelector } from "react-redux";

type ErrorsType = {
  name?: string;
  email?: string;
  role?: string;
  phone?: string;
};

const AccountInfo = () => {

  const { user, token } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [role, setRole] = useState<any>(null);

  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState<NotificationType | null>(null);
  const [errors, setErrors] = useState<ErrorsType>({});

  useEffect(() => {
    if (user) {
      const { name, email, phone, role } = user;

      let roleLabel = role.split("-").join(" ");

      const roleSelectValue = {
        value: role,
        label: roleLabel.charAt(0).toUpperCase() + roleLabel.slice(1)
      };

      setName(name);
      setEmail(email);
      setPhone(phone);
      setRole(roleSelectValue);
    };

    return () => { }
  }, [user]);

  const isValid = (payload: AdminAccountInfo) => {
    const { errors, isValid } = validateAccountInfo(payload);
    if (!isValid) {
      setErrors(errors);
    }
    return isValid;
  };

  const onSubmit = async() => {
    setIsLoading(true);
    setErrors({});
    setNotification(null);

    const payload = {
      _id: user._id,
      name,
      email,
      phone,
      role: role.value,
      isActive: true
    };

    if(isValid(payload)) {
      const response = await axios.post(`${API_URL}/admin/edit`, payload);
      const { status, data } = response;
      
      if(status === 200) {
        const {name, phone} = data.data;
        
        setName(name);
        setPhone(phone);

        const new_user = {
          ...user,
          name,
          phone
        };

        dispatch(setCredentials({ user: new_user, token }));
        setNotification({
          isError: false,
          title: "Sukses",
          text: "Data berhasil diperbarui",
        });
        
        setTimeout(() => {
          setIsLoading(false);
          setNotification(null);
        }, 3000);
      } else {
        setIsLoading(false);
        setNotification({
          isError: true,
          title: "Terjadi kesalahan",
          text: "Coba beberapa saat lagi.",
        });
      };
    } else {
      setIsLoading(false);
      setNotification({
        isError: true,
        title: "Data tidak lengkap",
        text: "Mohon lengkapi formulir di atas dengan benar",
      });
    };
  };

  return (
    <div className="bg-white p-4 rounded-xl mt-10">
      <h2 className="font-semibold">Informasi Admin</h2>
      <hr className="my-4" />
      <div>
        <TextInputDefault
          label="Email"
          placeholder="Masukkan email admin"
          name="email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={true}
          error={errors?.email}
        />
      </div>
      <div className="mt-3">
        <TextInputDefault
          label="Nama"
          placeholder="Masukkan nama admin"
          name="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          disabled={isLoading}
          error={errors?.name}
        />
      </div>
      <div className="mt-3">
        <TextInputDefault
          label="No. HP"
          placeholder="Masukkan nomor HP"
          name="phone"
          type="text"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          disabled={isLoading}
          error={errors?.phone}
        />
      </div>
      <div className="mt-3">
        <SelectInput
          isMulti={false}
          label='Jabatan'
          placeholder="Pilih jabatan"
          disabled={true}
          options={roleOptions}
          value={role}
          error={errors?.role}
          onChange={(value) => setRole(value)}
        />
      </div>

      <div className="mt-4">
        <Notification notification={notification} />
      </div>

      <div className='mt-8'>
        { isLoading ?
          <div>
            <Loading loading={isLoading} type='beat-loader' size={10} parentClass='text-sm' />
          </div>
          : <button
            type='submit'
            onClick={onSubmit}
            className='w-full justify-center bg-orange-600 text-white rounded-lg py-3 font-semibold'
          >
            Simpan
          </button>
        }
      </div>
    </div>
  )
}

export default AccountInfo